module.exports = __webpack_public_path__ + "static/media/owners.20be8fdc.jpg";